var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfinityloopRepeatCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.758 117.338C108.849 122.719 93.9015 137.753 80.0415 137.753V137.734L79.9934 137.753V137.753C67.7119 137.762 57.75 127.791 57.75 115.5C57.75 103.209 67.7119 93.2372 80.003 93.2468V93.2468L80.0511 93.2661V93.2468C93.9111 93.2468 108.859 108.271 113.768 113.661C113.758 113.661 115.5 115.5 115.5 115.5L113.758 117.338V117.338Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.242 117.338C122.151 122.719 137.098 137.753 150.959 137.753V137.734L151.007 137.753V137.753C163.288 137.762 173.25 127.791 173.25 115.5C173.25 103.209 163.288 93.2372 150.997 93.2468V93.2468L150.949 93.2661V93.2468C137.089 93.2468 122.141 108.271 117.233 113.661C117.242 113.661 115.5 115.5 115.5 115.5L117.242 117.338V117.338Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityloopRepeatCircle);
export default __webpack_public_path__ + "static/media/Infinity, loop, Repeat, Circle.ab5c750940241ebf07f67429020c388b.svg";
export { ForwardRef as ReactComponent };